import { WidgetType } from 'lib/enum/widget-type.enum';

import outlineSubscribeSvg from 'newAtomic/atoms/Icon/outline/subscribe.svg?raw';
import outlineCircleSuccessSvg from 'newAtomic/atoms/Icon/outline/circleSuccess.svg?raw';
import outlineCalendarSvg from 'newAtomic/atoms/Icon/outline/calendar.svg?raw';
import outlineAddUserSvg from 'newAtomic/atoms/Icon/outline/addUser.svg?raw';
import outlineOnboardingSvg from 'newAtomic/atoms/Icon/outline/onboarding.svg?raw';
import outlineRightSvg from 'newAtomic/atoms/Icon/outline/right.svg?raw';
import outlineChevronRightSvg from 'newAtomic/atoms/Icon/outline/chevronRight.svg?raw';
import outlineCircleArrowRightSvg from 'newAtomic/atoms/Icon/outline/circleArrowRight.svg?raw';
import outlineChatSvg from 'newAtomic/atoms/Icon/outline/chat.svg?raw';
import whatsappLogoSvg from 'newAtomic/atoms/Icon/whatsapp/logo.svg?raw';
import outlineChatbotSvg from 'newAtomic/atoms/Icon/outline/chatbot.svg?raw';
import outlineAllConversationsSvg from 'newAtomic/atoms/Icon/outline/allConversations.svg?raw';
import outlineConversationSvg from 'newAtomic/atoms/Icon/outline/conversation.svg?raw';
import outlineConversationSquareSvg from 'newAtomic/atoms/Icon/outline/conversationSquare.svg?raw';
import outlineStartConversationSvg from 'newAtomic/atoms/Icon/outline/startConversation.svg?raw';
import outlineEditSvg from 'newAtomic/atoms/Icon/outline/edit.svg?raw';
import outlineAiSvg from 'newAtomic/atoms/Icon/outline/ai.svg?raw';
import outlineSupportSvg from 'newAtomic/atoms/Icon/outline/support.svg?raw';
import outlineSendSvg from 'newAtomic/atoms/Icon/outline/send.svg?raw';
import { TalentCustomFieldDefinition } from '../TalentCustomFieldsDefinition/types';
import { Iri } from 'lib/utils/iri';

export enum ChannelType {
    WebChat = 'webChat',
    WhatsApp = 'whatsApp',
}

export enum ContentAvatarUrlType {
    BusinessAccount = 'businessAccount',
    AIAgent = 'aiAgent',
    OtherImage = 'otherImage',
}

export enum ReplyStyleType {
    InputField = 'inputField',
    ActionButton = 'actionButton',
}

export enum ShowWhatsAppIconType {
    Show = 'show',
    Hide = 'hide',
}

export enum BrandingType {
    PoweredByMrWork = 'poweredByMrWork',
    None = 'none',
}

export enum ThemeColorType {
    MrWork = 'mrWork',
    BusinessAccount = 'businessAccount',
    Custom = 'custom',
}

export enum HeaderBackgroundType {
    Gradient = 'gradient',
    Light = 'light',
    Dark = 'dark',
    Custom = 'custom',
}

export enum ChatBackgroundType {
    MrWork = 'mrWork',
    Whatsapp = 'whatsapp',
    ThemeColor = 'themeColor',
    Custom = 'custom',
}

export enum ChatActionButtonBackgroundType {
    Whatsapp = 'whatsapp',
    SameAsHeader = 'sameAsHeader',
    Custom = 'custom',
}

export enum ChatActionButtonColorType {
    Light = 'light',
    Dark = 'dark',
    Custom = 'custom',
}

export enum ButtonBackgroundType {
    Whatsapp = 'whatsapp',
    SameAsHeader = 'sameAsHeader',
    Custom = 'custom',
}

export enum AlignmentType {
    Left = 'left',
    Right = 'right',
}

export enum ButtonTextColorType {
    Light = 'light',
    Dark = 'dark',
    Custom = 'custom',
}

export enum HeaderTextColorType {
    Light = 'light',
    Dark = 'dark',
    Custom = 'custom',
}

export enum ButtonLayoutStyle {
    Standalone = 'standalone',
    CallToActionCard = 'callToActionCard',
}

export enum ImagePositionType {
    Left = 'left',
    Right = 'right',
}

export enum ButtonSizeType {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum StyleFontFontFamilyCodes {
    SameAsWebsite = 'inherit',
    Inter = 'Inter',
    Lato = 'Lato',
    Montserrat = 'Montserrat',
    NotoSans = 'Noto Sans',
    Poppins = 'Poppins',
    Raleway = 'Raleway',
    Roboto = 'Roboto',
    Ubuntu = 'Ubuntu',
}

export enum TextAlignmentType {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}

export enum ButtonPresentationType {
    Inline = 'inline',
    Floating = 'floating',
}

export enum LogoType {
    NoLogo = 'noLogo',
    BusinessAccount = 'businessAccount',
    OtherImage = 'otherImage',
}

export enum ButtonStyleType {
    Icon = 'icon',
    Text = 'text',
    IconAndText = 'iconAndText',
}

export enum BackgroundColorType {
    BusinessAccount = 'businessAccount',
    Default = 'default',
    Custom = 'custom',
}

export enum TextColorType {
    Light = 'light',
    Dark = 'dark',
    Custom = 'custom',
}

export enum ButtonBackgroundColorType {
    Whatsapp = 'whatsapp',
    Custom = 'custom',
}

export enum FormPresentationType {
    InlineEmbed = 'inlineEmbed',
    PopupModal = 'popupModal',
}

export enum TriggerType {
    Instant = 'instant',
    TimeDelay = 'timeDelay',
    OnScroll = 'onScroll',
    Manual = 'manual',
}

export enum ModalSizeType {
    StandardModal = 'standardModal',
    FullScreen = 'fullScreen',
}

export const ICON_NAMES_FOR_CHAT = [
    'outlineChat',
    'whatsappLogoOri',
    'outlineChatbot',
    'outlineAllConversations',
    'outlineConversation',
    'outlineConversationSquare',
    'outlineStartConversation',
    'outlineEdit',
    'outlineAi',
    'outlineSupport',
    'outlineSend',
] as const;

export const ICON_NAMES_FOR_FORM = [
    'outlineSend',
    'outlineSubscribe',
    'outlineCircleSuccess',
    'outlineCalendar',
    'outlineSupport',
    'outlineAddUser',
    'outlineOnboarding',
    'outlineRight',
    'outlineChevronRight',
    'outlineCircleArrowRight',
] as const;

export const ICON_NAMES_FOR_BUTTON = [
    'outlineChat',
    'whatsappLogoOri',
    'outlineChatbot',
    'outlineAllConversations',
    'outlineConversation',
    'outlineConversationSquare',
    'outlineStartConversation',
    'outlineEdit',
    'outlineAi',
    'outlineSupport',
    'outlineSend',
] as const;

export type IconNameTypeForChat = (typeof ICON_NAMES_FOR_CHAT)[number];
export type IconNameTypeForForm = (typeof ICON_NAMES_FOR_FORM)[number];
export type IconNameTypeForButton = (typeof ICON_NAMES_FOR_BUTTON)[number];

const resizeSvgTo24px = (svgString: string): string => {
    return svgString
        .replace(/width="16"/g, 'width="24"')
        .replace(/height="16"/g, 'height="24"')
        .replace(/width="17"/g, 'width="24"')
        .replace(/height="17"/g, 'height="24"')
        .replace(/width="18"/g, 'width="24"')
        .replace(/height="18"/g, 'height="24"');
};

export const BUTTON_ICONS_SVG_FOR_CHAT: Record<IconNameTypeForChat, string> = {
    outlineChat: resizeSvgTo24px(outlineChatSvg),
    whatsappLogoOri: resizeSvgTo24px(whatsappLogoSvg),
    outlineChatbot: resizeSvgTo24px(outlineChatbotSvg),
    outlineAllConversations: resizeSvgTo24px(outlineAllConversationsSvg),
    outlineConversation: resizeSvgTo24px(outlineConversationSvg),
    outlineConversationSquare: resizeSvgTo24px(outlineConversationSquareSvg),
    outlineStartConversation: resizeSvgTo24px(outlineStartConversationSvg),
    outlineEdit: resizeSvgTo24px(outlineEditSvg),
    outlineAi: resizeSvgTo24px(outlineAiSvg),
    outlineSupport: resizeSvgTo24px(outlineSupportSvg),
    outlineSend: resizeSvgTo24px(outlineSendSvg),
};

export const BUTTON_ICONS_SVG_FOR_FORM: Record<IconNameTypeForForm, string> = {
    outlineSend: resizeSvgTo24px(outlineSendSvg),
    outlineSubscribe: resizeSvgTo24px(outlineSubscribeSvg),
    outlineCircleSuccess: resizeSvgTo24px(outlineCircleSuccessSvg),
    outlineCalendar: resizeSvgTo24px(outlineCalendarSvg),
    outlineSupport: resizeSvgTo24px(outlineSupportSvg),
    outlineAddUser: resizeSvgTo24px(outlineAddUserSvg),
    outlineOnboarding: resizeSvgTo24px(outlineOnboardingSvg),
    outlineRight: resizeSvgTo24px(outlineRightSvg),
    outlineChevronRight: resizeSvgTo24px(outlineChevronRightSvg),
    outlineCircleArrowRight: resizeSvgTo24px(outlineCircleArrowRightSvg),
};

export const BUTTON_ICONS_SVG_FOR_BUTTON: Record<IconNameTypeForButton, string> = {
    outlineChat: resizeSvgTo24px(outlineChatSvg),
    whatsappLogoOri: resizeSvgTo24px(whatsappLogoSvg),
    outlineChatbot: resizeSvgTo24px(outlineChatbotSvg),
    outlineAllConversations: resizeSvgTo24px(outlineAllConversationsSvg),
    outlineConversation: resizeSvgTo24px(outlineConversationSvg),
    outlineConversationSquare: resizeSvgTo24px(outlineConversationSquareSvg),
    outlineStartConversation: resizeSvgTo24px(outlineStartConversationSvg),
    outlineEdit: resizeSvgTo24px(outlineEditSvg),
    outlineAi: resizeSvgTo24px(outlineAiSvg),
    outlineSupport: resizeSvgTo24px(outlineSupportSvg),
    outlineSend: resizeSvgTo24px(outlineSendSvg),
};

export type ChatWidgetConfigWindowDevice =
    | {
          trigger: TriggerType.Instant;
          delayDuration: null;
          scrollThreshold: null;
          messageSpeed: number;
          allowWindowExpansion: boolean;
      }
    | {
          trigger: TriggerType.TimeDelay;
          delayDuration: number;
          scrollThreshold: null;
          messageSpeed: number;
          allowWindowExpansion: boolean;
      }
    | {
          trigger: TriggerType.OnScroll;
          delayDuration: null;
          scrollThreshold: number;
          messageSpeed: number;
          allowWindowExpansion: boolean;
      }
    | {
          trigger: TriggerType.Manual;
          delayDuration: null;
          scrollThreshold: null;
          messageSpeed: number;
          allowWindowExpansion: boolean;
      };

export type ChatWidgetConfigChat =
    | {
          messages: {
              id: string;
              message: string;
          }[];
          replyStyleType: ReplyStyleType.ActionButton;
          actionButtonText: string;
          showWhatsAppIcon: boolean;
          placeholder: null;
          prefilledMessage: null;
          backgroundColor: string | null;
          backgroundImage: string | null;
          actionButtonBackgroundColor: string;
          actionButtonColor: string;
          actionButtonCorners: number;
      }
    | {
          messages: {
              id: string;
              message: string;
          }[];
          replyStyleType: ReplyStyleType.InputField;
          actionButtonText: null;
          showWhatsAppIcon: null;
          placeholder: string;
          prefilledMessage: string;
          backgroundColor: string | null;
          backgroundImage: string | null;
          actionButtonBackgroundColor: string;
          actionButtonColor: string;
          actionButtonCorners: number;
      };

export type ChatWidgetConfig = {
    channelType: ChannelType;
    whatsappNumber: string;
    window: {
        themeColor: string;
        corners: number;
        fontStyle: StyleFontFontFamilyCodes;
        desktop: ChatWidgetConfigWindowDevice;
        mobile: ChatWidgetConfigWindowDevice;
    };
    header: {
        title: string;
        subtitle: string;
        avatar: string;
        backgroundColor: string | null;
        backgroundGradient: string | null;
        textColor: string;
    };
    chat: ChatWidgetConfigChat;
    footer: {
        branding: BrandingType;
    };
    button: {
        desktop: {
            icon: string | null;
            text: string | null;
            alignment: AlignmentType;
            sideSpacing: number;
            bottomSpacing: number;
        };
        mobile: {
            icon: string | null;
            text: string | null;
            alignment: AlignmentType;
            sideSpacing: number;
            bottomSpacing: number;
        };
        size: ButtonSizeType;
        corners: number;
        backgroundColor: string;
        textColor: string;
        customButtons: string[];
    };
};

export type ChatWidgetConfigMetadata = {
    createdInNewForm?: boolean;
    generalChannelType?: ChannelType;
    contentAvatarUrlType?: ContentAvatarUrlType;
    contentReplyStyleType?: ReplyStyleType;
    contentButtonDesktopStyleType?: ButtonStyleType;
    contentButtonMobileStyleType?: ButtonStyleType;
    contentButtonIconName?: IconNameTypeForChat | null;
    appearanceThemeColorType?: ThemeColorType;
    appearanceHeaderBackgroundColorType?: HeaderBackgroundType;
    appearanceHeaderTextColorType?: HeaderTextColorType;
    appearanceChatBackgroundColorType?: ChatBackgroundType;
    appearanceActionButtonBackgroundColorType?: ChatActionButtonBackgroundType;
    appearanceActionButtonColorType?: ChatActionButtonColorType;
    appearanceButtonBackgroundColorType?: ButtonBackgroundType;
    appearanceButtonTextColorType?: ButtonTextColorType;
};

export type CreateChatWidget = {
    uuid: string;
    name: string;
    type: WidgetType.Chat;
    config: ChatWidgetConfig;
    configMetadata: ChatWidgetConfigMetadata;
};

export enum FormFieldType {
    FirstName = 'firstName',
    LastName = 'lastName',
    Phone = 'phone',
    Email = 'email',
    Location = 'location',
    JobTitle = 'jobTitle',
    CurrentEmployer = 'currentEmployer',
    FacebookUrl = 'facebookUrl',
    LinkedinUrl = 'linkedinUrl',
    TextInput = 'textInput',
    NumberInput = 'numberInput',
    Textarea = 'textarea',
    Checkbox = 'checkbox',
    Select = 'select',
    MultiSelect = 'multi-select',
    DateTimePicker = 'dateTimePicker',
    Attachment = 'attachment',
    Custom = 'custom',
}

export enum AttachmentDocumentType {
    CV = 'CV',
    CoverLetter = 'COVER_LETTER',
    Other = 'OTHER',
}

export enum InputType {
    TextInput = 'textInput',
    NumberInput = 'numberInput',
    Textarea = 'textarea',
    Checkbox = 'checkbox',
    Select = 'select',
    MultiSelect = 'multi-select',
    DateTimePicker = 'dateTimePicker',
}

export const ADDITIONAL_DATA_FIELD_TYPES: FormFieldType[] = [
    FormFieldType.Checkbox,
    FormFieldType.TextInput,
    FormFieldType.Textarea,
    FormFieldType.Select,
    FormFieldType.MultiSelect,
];

export const getFormFieldTypeLabel = (
    fieldTypeId: FormFieldType | string,
    talentCustomFields: TalentCustomFieldDefinition[],
): string => {
    const talentCustomField = talentCustomFields.find(field => field.key === fieldTypeId);
    if (talentCustomField) {
        return talentCustomField.displayName;
    }
    switch (fieldTypeId) {
        case FormFieldType.FirstName:
            return 'First name';
        case FormFieldType.LastName:
            return 'Last name';
        case FormFieldType.Phone:
            return 'Phone';
        case FormFieldType.Email:
            return 'Email';
        case FormFieldType.TextInput:
            return 'Text field';
        case FormFieldType.NumberInput:
            return 'Number field';
        case FormFieldType.DateTimePicker:
            return 'Date field';
        case FormFieldType.Textarea:
            return 'Text area';
        case FormFieldType.Checkbox:
            return 'Checkbox';
        case FormFieldType.Select:
            return 'Single-select';
        case FormFieldType.MultiSelect:
            return 'Multi-select';
        case FormFieldType.Location:
            return 'Location';
        case FormFieldType.JobTitle:
            return 'Job Title';
        case FormFieldType.CurrentEmployer:
            return 'Current Employer';
        case FormFieldType.LinkedinUrl:
            return 'LinkedIn Profile';
        case FormFieldType.FacebookUrl:
            return 'Facebook Profile';
        case FormFieldType.Attachment:
            return 'Attachment';
        default:
            return 'Unknown field type';
    }
};

export enum InitialStateType {
    Empty = 'empty',
    Placeholder = 'placeholder',
    DefaultValue = 'defaultValue',
}

export enum VisibilityType {
    Visible = 'visible',
    Hidden = 'hidden',
}

export enum RequirementType {
    Required = 'required',
    Optional = 'optional',
}

export enum BorderSizeType {
    Zero = 0,
    One = 1,
    Two = 2,
    Three = 3,
    Four = 4,
    Five = 5,
}

export enum FieldCardinality {
    One = 'one',
    Many = 'many',
}

type BaseFormWidgetFormField = {
    id: string;
    label: string;
    visibility: VisibilityType;
    requirement: RequirementType;
};

type StandardFormWidgetFormFieldType = Exclude<FormFieldType, FormFieldType.Attachment>;

type BaseStandardFormWidgetFormField = BaseFormWidgetFormField & {
    type: StandardFormWidgetFormFieldType;
    name: string;
    options: string[];
    inputType: InputType;
    min: number | null;
    max: number | null;
    cardinality: FieldCardinality | null;
    documentType?: never;
};

type EmptyStandardFormWidgetFormField = BaseStandardFormWidgetFormField & {
    initialState: InitialStateType.Empty;
    placeholder: null;
    defaultValue: null;
};

type PlaceholderStandardFormWidgetFormField = BaseStandardFormWidgetFormField & {
    initialState: InitialStateType.Placeholder;
    placeholder: string;
    defaultValue: null;
};

type DefaultValueStandardFormWidgetFormField = BaseStandardFormWidgetFormField & {
    initialState: InitialStateType.DefaultValue;
    placeholder: null;
    defaultValue: string;
};

export type StandardFormWidgetFormField =
    EmptyStandardFormWidgetFormField | PlaceholderStandardFormWidgetFormField | DefaultValueStandardFormWidgetFormField;

export type AttachmentFormWidgetFormField = BaseFormWidgetFormField & {
    type: FormFieldType.Attachment;
    documentType: AttachmentDocumentType;
    initialState?: never;
    placeholder?: never;
    defaultValue?: never;
    name?: never;
    options?: never;
    inputType?: never;
    min?: never;
    max?: never;
    cardinality?: never;
};

export type FormWidgetFormField = StandardFormWidgetFormField | AttachmentFormWidgetFormField;

export const isAttachmentFormFieldType = (fieldType: string): fieldType is FormFieldType.Attachment =>
    fieldType === FormFieldType.Attachment;

export const isAttachmentFormField = (field: FormWidgetFormField): field is AttachmentFormWidgetFormField =>
    isAttachmentFormFieldType(field.type);

export type FormWidgetConfigFormDevice =
    | {
          presentation: FormPresentationType;
          trigger: TriggerType.Instant;
          delayDuration: null;
          scrollThreshold: null;
          modalSize: ModalSizeType;
      }
    | {
          presentation: FormPresentationType;
          trigger: TriggerType.TimeDelay;
          delayDuration: number;
          scrollThreshold: null;
          modalSize: ModalSizeType;
      }
    | {
          presentation: FormPresentationType;
          trigger: TriggerType.OnScroll;
          delayDuration: null;
          scrollThreshold: number;
          modalSize: ModalSizeType;
      }
    | {
          presentation: FormPresentationType;
          trigger: TriggerType.Manual;
          delayDuration: null;
          scrollThreshold: null;
          modalSize: ModalSizeType;
      };

export type FormWidgetConfigButtonDevice =
    | {
          icon: string | null;
          text: string | null;
          presentation: ButtonPresentationType.Inline;
          alignment: null;
          sideSpacing: null;
          bottomSpacing: null;
      }
    | {
          icon: string | null;
          text: string | null;
          presentation: ButtonPresentationType.Floating;
          alignment: TextAlignmentType;
          sideSpacing: number;
          bottomSpacing: number;
      };

export type FormWidgetConfig = {
    window: {
        image: string | null;
        imagePosition: ImagePositionType | null;
        logo: string | null;
        backgroundColor: string;
        corners: number;
        desktop: FormWidgetConfigFormDevice;
        mobile: FormWidgetConfigFormDevice;
    };
    text: {
        title: string;
        subtitle: string;
        bodyText: string;
        footer: string;
        fontStyle: StyleFontFontFamilyCodes;
        alignment: TextAlignmentType;
        color: string;
    };
    form: {
        fields: FormWidgetFormField[];
        backgroundColor: string;
        borderSize: BorderSizeType;
        borderColor: string;
        submitButton: {
            corners: number;
            backgroundColor: string;
            text: string;
            textColor: string;
        };
        confirmationPageUrl: string;
    };
    button: {
        desktop: FormWidgetConfigButtonDevice;
        mobile: FormWidgetConfigButtonDevice;
        corners: number;
        backgroundColor: string;
        textColor: string;
        customButtons: string[];
        size: ButtonSizeType;
    };
};

export type FormWidgetConfigMetadata = {
    createdInNewForm?: boolean;
    contentVisualsImagePosition?: ImagePositionType | null;
    contentVisualsLogoType?: LogoType;
    contentButtonDesktopIconStyleType?: ButtonStyleType;
    contentButtonMobileIconStyleType?: ButtonStyleType;
    contentButtonDesktopIconName?: IconNameTypeForForm | null;
    contentButtonMobileIconName?: IconNameTypeForForm | null;
    appearanceWindowBackgroundColorType?: BackgroundColorType;
    appearanceTextColorType?: HeaderTextColorType;
    appearanceFormBackgroundColorType?: BackgroundColorType;
    appearanceFormBorderColorType?: BackgroundColorType;
    appearanceSubmitButtonBackgroundColorType?: BackgroundColorType;
    appearanceSubmitButtonTextColorType?: HeaderTextColorType;
    appearanceButtonBackgroundColorType?: BackgroundColorType;
    appearanceButtonTextColorType?: HeaderTextColorType;
};

export type CreateFormWidget = {
    uuid: string;
    name: string;
    type: WidgetType.Form;
    config: FormWidgetConfig;
    configMetadata: FormWidgetConfigMetadata;
};

export type ButtonWidgetConfigButtonDevice =
    | {
          icon: string | null;
          text: string | null;
          prefilledMessage: string | null;
          presentationType: ButtonPresentationType.Inline;
          alignment: null;
          sideSpacing: null;
          bottomSpacing: null;
      }
    | {
          icon: string | null;
          text: string | null;
          prefilledMessage: string | null;
          presentationType: ButtonPresentationType.Floating;
          alignment: TextAlignmentType;
          sideSpacing: number;
          bottomSpacing: number;
      };

export type ButtonWidgetConfigButton = {
    desktop: ButtonWidgetConfigButtonDevice;
    mobile: ButtonWidgetConfigButtonDevice;
    size: ButtonSizeType;
    corners: number;
    backgroundColor: string;
    textColor: string;
    customButtons: string[];
};

export type ButtonWidgetConfig =
    | {
          whatsappNumber: string;
          layoutStyle: ButtonLayoutStyle.Standalone;
          button: ButtonWidgetConfigButton;
          triggerButton: null;
          popup: null;
      }
    | {
          whatsappNumber: string;
          layoutStyle: ButtonLayoutStyle.CallToActionCard;
          triggerButton: ButtonWidgetConfigButton;
          button: ButtonWidgetConfigButton;
          popup: {
              title: string;
              subtitle: string;
              bodyText: string;
              footer: string;
              image: string | null;
              imagePosition: ImagePositionType | null;
              logo: string | null;
              backgroundColor: string;
              corners: number;
              fontFamily: StyleFontFontFamilyCodes;
              textAlignment: TextAlignmentType;
              textColor: string;
              desktop: {
                  presentation: FormPresentationType;
                  trigger: TriggerType;
                  delayDuration: number;
                  scrollThreshold: number;
                  modalSize: ModalSizeType;
              };
              mobile: {
                  presentation: FormPresentationType;
                  trigger: TriggerType;
                  delayDuration: number;
                  scrollThreshold: number;
                  modalSize: ModalSizeType;
              };
          };
      };

export type ButtonWidgetConfigMetadata = {
    createdInNewForm?: boolean;
    contentPopupVisualsLogoType?: LogoType;
    contentButtonDesktopIconStyleType?: ButtonStyleType;
    contentButtonMobileIconStyleType?: ButtonStyleType;
    contentButtonDesktopIconName?: IconNameTypeForButton | null;
    contentButtonMobileIconName?: IconNameTypeForButton | null;
    appearancePopupBackgroundColorType?: BackgroundColorType;
    appearancePopupTextColorType?: TextColorType;
    appearanceButtonBackgroundColorType?: ButtonBackgroundColorType;
    appearanceButtonTextColorType?: TextColorType;
};

export type CreateButtonWidget = {
    uuid: string;
    name: string;
    type: WidgetType.Button;
    config: ButtonWidgetConfig;
    configMetadata: ButtonWidgetConfigMetadata;
};

export enum WidgetStatus {
    Draft = 'draft',
    Enabled = 'enabled',
    Disabled = 'disabled',
}

export type Widget = {
    id: string;
    businessAccount: Iri;
    name: string;
    type: WidgetType;
    status: WidgetStatus;
    updatedAt: string;
};

export type ChatWidgetWithConfig = {
    id: string;
    businessAccount: Iri;
    name: string;
    type: WidgetType.Chat;
    status: WidgetStatus;
    updatedAt: string;
    config: ChatWidgetConfig;
    configMetadata: ChatWidgetConfigMetadata;
};

export type FormWidgetWithConfig = {
    id: string;
    businessAccount: Iri;
    name: string;
    type: WidgetType.Form;
    status: WidgetStatus;
    updatedAt: string;
    config: FormWidgetConfig;
    configMetadata: FormWidgetConfigMetadata;
};

export type ButtonWidgetWithConfig = {
    id: string;
    businessAccount: Iri;
    name: string;
    type: WidgetType.Button;
    status: WidgetStatus;
    updatedAt: string;
    config: ButtonWidgetConfig;
    configMetadata: ButtonWidgetConfigMetadata;
};
